module.exports = __webpack_public_path__ + "img/banner-10.70318678.jpg";